export const buttonBox = theme => ({
  [theme.breakpoints.up('md')]: {
    alignItems: 'flex-end',
    display: 'flex',
    flexDirection: 'column',
    gridColumnStart: 3,
    justifyContent: 'flex-start',
  },
});

export const content = theme => ({
  gridColumnStart: 2,
  gridRowStart: 2,
  margin: theme.spacing(1, 'auto', 3),
});

export const header = theme => ({
  [theme.breakpoints.up('md')]: {
    gridColumnStart: 2,
    gridRowStart: 1,
  },
});

export const infoIcon = {
  height: 18,
  width: 18,
};

export const layout = theme => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  // overflow: 'hidden',
  padding: theme.spacing(0, 3, 3),
  width: '100%',
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(0, 3),
  },
});

export const rulesButtonStyles = theme => ({
  alignItems: 'rignt',
  color: theme.palette.primary.main,
  display: 'flex',
  gridColumnStart: 'unset',
  justifyContent: 'end',
  marginBottom: theme.spacing(2),
  width: 130,
  [theme.breakpoints.up('md')]: {
    marginBottom: theme.spacing(6),
  },
});

export const scroll = theme => ({
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  [theme.breakpoints.down('lg')]: {
    marginBottom: theme.spacing(8),
    overflowY: 'auto',
  },
});
